"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const initialData_1 = __importDefault(require("./initialData"));
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const schema_1 = __importDefault(require("./schema"));
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const uiSchema_1 = __importDefault(require("./uiSchema"));
const mapper_1 = require("./mapper");
const recertTemplate = {
    formToPayloadDataHandler: formToPayloadDataHandler_1.recertFormToPayloadDataHandler,
    payloadToFormDataHandler: payloadToFormDataHandler_1.recertPayloadToFormDataHandler,
    initialData: initialData_1.default,
    schema: schema_1.default,
    uiSchema: uiSchema_1.default,
    templateMapper: mapper_1.templateMapper,
};
exports.default = recertTemplate;
